/* eslint-disable class-methods-use-this */

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import { Component } from 'react'

import { checkPassword } from '../../utils/validation'
import StatusLabel from '../StatusLabel'

class PasswordCheck extends Component {
  constructor(props) {
    super(props)
    this.state = {
      charLength: false,
      capitalLetter: false,
      numberEntered: false,
      specialChar: false,
    }
  }

  componentWillMount() {
    const { password, charLength, capitalLetter, numberEntered, specialChar } = this.props
    const newState = checkPassword(password.value, charLength, capitalLetter, numberEntered, specialChar)
    this.setState({ ...newState })
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps.password
    if (value !== this.props.password.value) {
      const newState = checkPassword(value, this.charLength, this.capitalLetter, this.numberEntered, this.specialChar)
      this.setState({ ...newState })
      this.props.onChange({ ...newState })
    }
  }

  renderPasswordRule = (status, label) => {
    if (status) {
      return <StatusLabel icon="tick" iconSize={16} label={label} variant="white" />
    }
    return <StatusLabel icon="removeCircle" iconSize={16} label={label} variant="white" />
  }

  renderPasswordStrength = () => {
    const { classes } = this.props
    const { charLength, capitalLetter, numberEntered, specialChar } = this.state

    let strengthLevel = 0
    let fontColor = ''
    let strengthWord = ''

    if (charLength) strengthLevel += 1
    if (capitalLetter) strengthLevel += 1
    if (numberEntered) strengthLevel += 1
    if (specialChar) strengthLevel += 1

    switch (strengthLevel) {
      case 1:
        fontColor = '#D0061B'
        strengthWord = 'Weak'
        break
      case 2:
        fontColor = '#FE9F01'
        strengthWord = 'Average'
        break
      case 3:
        fontColor = '#007AFF'
        strengthWord = 'Good'
        break
      case 4:
        fontColor = '#1CAE46'
        strengthWord = 'Strong'
        break
      default:
        fontColor = '#D0061B'
        strengthWord = 'Weak'
        break
    }
    return (
      <div className={cn(classes.passwordStrength)}>
        Password Strength:{' '}
        <font className={classes.strengthWord} style={{ backgroundColor: fontColor }}>
          {strengthWord}
        </font>
      </div>
    )
  }

  render() {
    const { classes, password } = this.props
    const { capitalLetter, charLength, numberEntered, specialChar } = this.state
    return (
      <div className={classes.passwordCheck}>
        {password.value.length > 0 ? (
          <div className={classes.passwordCheckHeader}>{this.renderPasswordStrength()}</div>
        ) : (
          ''
        )}
        <div className={classes.passwordCheckHeader}>Make sure to include at least:</div>
        <ul className={cn(classes.list)}>
          <li className={cn(classes.listItem)}>{this.renderPasswordRule(charLength, '8 characters')}</li>
          <li className={cn(classes.listItem)}>{this.renderPasswordRule(capitalLetter, '1 capital letter')}</li>
          <li className={cn(classes.listItem)}>{this.renderPasswordRule(numberEntered, '1 number')}</li>
          <li className={cn(classes.listItem)}>{this.renderPasswordRule(specialChar, '1 special character eg. #@')}</li>
        </ul>
      </div>
    )
  }
}

const styles = theme => ({
  passwordStrength: {
    fontSize: '14px',
  },
  strengthWord: {
    padding: '0 4px',
    borderRadius: '4px',
  },
  passwordCheck: {
    fontSize: theme.typography.fontSizeSm,
    padding: '16px',
  },
  passwordCheckHeader: {
    marginBottom: '8px',
  },
  list: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  listItem: {
    marginBottom: '0rem',
    textAlign: 'left',
  },
})

export default withStyles(styles)(PasswordCheck)
